module.exports = __webpack_public_path__ + "img/shoot_00038.28504217.png";